import React from 'react';

const AuthButton = ({
  type = "submit",
  onClick,
  isLoading = false,
  disabled = false,
  children,
  fullWidth = true,
  className = '',
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={isLoading || disabled}
      className={`
        ${fullWidth ? 'w-full' : ''}
        flex justify-center items-center 
        py-3 px-6 
        border border-transparent rounded-lg shadow-md 
        text-base font-semibold text-white 
        bg-brand-accent-orange hover:bg-orange-600 
        focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-accent-orange
        transition duration-150 ease-in-out
        disabled:opacity-60 disabled:cursor-not-allowed
        ${className}
      `}
    >
      {isLoading ? (
        <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
      ) : (
        children
      )}
    </button>
  );
};

export default AuthButton;
